/**
 * Gắn ký cho axios MẶC ĐỊNH. Nhiều chỗ gọi thẳng axios.get/post (languageAPI,
 * enterpriseAPI, baseApi.getByUrl, refresh token trong interceptor.js) — import
 * file này ở đầu src/index.js để gắn trước mọi request.
 */
import axios from 'axios';
import { attachSigning } from './index';

attachSigning(axios);
